module.exports = __webpack_public_path__ + "img/Operations-action.8297d4b0.svg";